export class RegExpUtils {
  public static getExtensionsRegExp() {
    return /\.[^/.]+$/
  }

  public static getEmailRegExp() {
    return /^[\w-.]+@([\w-]+\.)+[\w]{2,}$/
  }
}
